<script lang="ts" setup>
import LoadingSpinner from '@webapp2/shared/components/icons/LoadingSpinner.vue'
import { type IconName } from '@webapp2/shared/components/icons/material-icon'
import MaterialIcon from '@webapp2/shared/components/icons/MaterialIcon.vue'
import { computed } from 'vue'

const props = defineProps<{
  variant?: 'outline'
  size?: 'xs' | 'sm' | 'md' | 'lg'
  icon?: IconName
  busy?: boolean
}>()

const iconSizes = {
  xs: 'w-4',
  sm: 'w-6',
  md: 'w-8',
  lg: 'w-10'
}

const textSizes = {
  xs: 'text-sm',
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-xl'
}

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'outline':
      return 'border-2 border-surface-300 text-color bg-surface-0 hover:bg-surface-100 disabled:hover:bg-transparent'
    default:
      return 'bg-primary text-primary-contrast hover:bg-primary-emphasis disabled:hover:bg-primary'
  }
})

const size = computed(() => props.size ?? 'md')
</script>

<template>
  <button
    type="button"
    :class="`font-outfit ${textSizes[size]} ${variantClasses} py-2 px-4 flex items-center justify-center gap-3 cursor-pointer font-semibold rounded-xl transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed`"
    :disabled="busy"
  >
    <LoadingSpinner v-if="busy" :class="`${iconSizes[size]} h-full shrink-0`" />
    <MaterialIcon v-else-if="icon" :name="icon" :class="`${iconSizes[size]} h-full shrink-0`" />
    <slot></slot>
  </button>
</template>
